// TODO: Move team data from App.tsx here
export const team = [
  {
    name: 'russell',
    role: 'cofounderRole',
    country: '🇺🇸'
  },
  {
    name: 'blake',
    role: 'cofounderRole',
    country: '🇺🇸'
  },
  {
    name: 'juan',
    role: 'argentinaRepRole',
    country: '🇦🇷'
  },
  {
    name: 'eduardo',
    role: 'independentImportSpecialist',
    country: '🇦🇷'
  }
];
